export default __webpack_public_path__ + "static/media/chargedblast.a5eb79cd.png";